import { defineStore } from 'pinia'

import type { CustomersStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useCustomersStore = defineStore('customers', {
  state: (): CustomersStore => ({
    loading: false,
    customers: [],
    meta: null,
    filterSearch: null,
    filterStatus: null,
    filterStages: [],
    filterFrom: null,
    filterTo: null,
    filterSourceFunnel: null,
    filterTutorId: null,
    filterStudyingStatus: null,
    currentPage: 1,
    perPage: 25,
    deleteCustomerId: null,
    deleting: false,
  }),
  actions,
  getters,
})
